import { render, staticRenderFns } from "./ChargeTransactionsModal.vue?vue&type=template&id=871085fa&scoped=true"
import script from "./ChargeTransactionsModal.vue?vue&type=script&lang=js"
export * from "./ChargeTransactionsModal.vue?vue&type=script&lang=js"
import style0 from "./ChargeTransactionsModal.vue?vue&type=style&index=0&id=871085fa&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "871085fa",
  null
  
)

export default component.exports